/* eslint-disable @typescript-eslint/no-require-imports */
export const mainHomeHeroImageXS = require('./grass-fed-on-wooden-table.jpg');
export const mainHomeHeroImageSM = require('./grass-fed-on-grass.jpg');
